import React from 'react';
import { observer } from 'mobx-react';
import store from '../store/store.js'
import IconButton from 'material-ui/IconButton';
import NavigationChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ActionHome from 'material-ui/svg-icons/action/home';


const BackButton = observer((props) => {

  const backButton = store.isBackButton
        ? ( <IconButton onClick={store.backFunction}><NavigationChevronLeft color="white"/> </IconButton> )
        : ( <IconButton> <ActionHome color="white" /> </IconButton> );

  return backButton;
});

export default BackButton;


// WEBPACK FOOTER //
// ./src/coms/BackButton.jsx